module.exports = __webpack_public_path__ + "assets/img/thumb-HR-Connect-Website.a2937ae1.webp";